import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Tax } from '../../../../../projects/shared-lib/src/lib/models/tax';
import { ShippingService } from '../../../shipping/services/shipping.service';
import { ShippingModeRest } from '../../../../../projects/shared-lib/src/lib/models/shipping-mode-rest';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NgClass, CurrencyPipe, JsonPipe } from '@angular/common';
import { CartService } from '../../../../../projects/shared-lib/src/lib/services/cart.service';

@Component({
    selector: 'tw-cart-tax-view',
    templateUrl: './cart-tax-view.component.html',
    styleUrls: ['./cart-tax-view.component.css'],
    imports: [NgClass, CurrencyPipe, TranslatePipe, JsonPipe],
})
export class CartTaxViewComponent implements OnInit, OnDestroy {
    @Input() tax: Tax | any;
    @Input() canTaxOverride: boolean = true;
    @Input() typeStyle: any = 1;
    @Input() giftAmount: any = 0;
    @Input() totalToPay: any = 0;
    @Input() watchCart = true;

    totalShippingSelected = 0;
    total = 0;
    hasShipping = false;
    hasOnlySubtotal = false;
    _sub = [];

    constructor(
        private shippingService: ShippingService,
        public translate: TranslateService,
        private cartService: CartService,
    ) {}

    ngOnDestroy(): void {
        this._sub.forEach((s) => s.unsubscribe());
    }

    ngOnInit() {
        if (!this.giftAmount) {
            this.giftAmount = 0;
        }
        this.totalSipping();
        if (this.watchCart) {
            const a = this.shippingService.watchShippingSelect().subscribe(() => {
                this.totalSipping();
            });
            this._sub.push(a);
            if (!this.tax) {
                const b = this.cartService.cartSub.subscribe((cart) => {
                    if (cart && cart?.tax && this.canTaxOverride) {
                        this.tax = cart.tax;
                        this.totalSipping();
                    }
                });
                this._sub.push(b);
            }
        }
    }

    totalSipping() {
        this.totalShippingSelected = 0;
        const temp = this.shippingService.getShippingSelectedLocal();
        if (temp) {
            this.hasShipping = true;
            Object.keys(temp)?.forEach((value) => {
                //console.log(temp[value].price);
                try {
                    this.totalShippingSelected = this.totalShippingSelected + temp[value].price;
                } catch (e) {
                    console.log(e);
                }
            });
        }
        this.hasOnlySubtotal = this.tax.totalAfterTaxes === this.tax.totalBeforeTaxes && this.tax.totalBeforeTaxes === this.tax.subtotal;
        this.setTotal();
        if (this.hasOnlySubtotal && !this.hasShipping) {
            this.typeStyle = 3;
        }
    }

    setTotal() {
        if (!this.giftAmount) {
        }
        this.total = this.tax.totalAfterTaxes + this.totalShippingSelected - this.giftAmount;
        console.log(this.tax.totalAfterTaxes, this.totalShippingSelected, this.giftAmount);
        console.log(this.total);
    }
}
